import { render, staticRenderFns } from "./FavoriteRecipeCarroussel.vue?vue&type=template&id=5a5d06e4&scoped=true"
import script from "./FavoriteRecipeCarroussel.vue?vue&type=script&lang=js"
export * from "./FavoriteRecipeCarroussel.vue?vue&type=script&lang=js"
import style0 from "./FavoriteRecipeCarroussel.vue?vue&type=style&index=0&id=5a5d06e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d06e4",
  null
  
)

export default component.exports